import {
  Typography,
  Divider,
} from 'antd';
import { TradeContextProvider } from '../../contexts/tradeProcessContext';
import StepCounter from './StepCounter';

const { Title } = Typography;

const TradeProcess = () => {
  return (
    <TradeContextProvider>
      <Title level={4}>Trade Process</Title>
      <Divider />
      <StepCounter />
    </TradeContextProvider>
  );
};

export default TradeProcess;
